import { createSelector } from '@ngrx/store';

import { FragmentLinks } from '../../models';
import { getCitation } from './get.citations';

export const getFragmentLinks = createSelector(
  [getCitation],
  ({ fragmentLinks }): FragmentLinks => fragmentLinks
);
